import { lazier } from '@shared/components';

export const DeclineAdvancementModal = lazier(
  () => import('./DeclineAdvancementModal'),
  false,
);
